import React, { useEffect } from "react";
import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next, I18nextProvider } from "react-i18next";

import en from "../static/i18n/translations/en.json";
import es from "../static/i18n/translations/es.json";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: "es",
    resources: {
      es: { translation: es },
      en: { translation: en },
    },
    languages: ["es", "en"],
    debug: false,
    interpolation: {
      escapeValue: false,
    },
    react: {
      wait: true,
      useSuspense: false,
    },
    detection: {
      // order and from where user language should be detected
      order: ["cookie"],

      // keys or params to lookup language from
      lookupCookie: "i18nextLng",

      // cache user language on
      caches: ["cookie"],
      cookieExpirationDate: 14000,
      cookieDomain: "localhost",
    },
  });

const I18NProv = ({ children, locale }) => {
  useEffect(() => {
    i18n.changeLanguage(locale);
  }, [locale]);

  return <I18nextProvider i18n={i18n}>{children}</I18nextProvider>;
};

export default I18NProv;
